<template>
  <div class="trade-page ">
		<div class="top-main flex-center-between">
			<div class="flex-center">
				<Icon name="star" size="24" color="#85898F" @click="changeFollowStatus(0)"  v-if="isFollow"></Icon>
				<Icon name="star-o" size="24" color="#85898F" @click="changeFollowStatus(1)" v-else></Icon>
				<img class="big" :src="bitInfo.Logo ? `/upload/${bitInfo.Logo}` : bitUrl" alt="">
				<span class="name">{{bitInfo && bitInfo.ShortName ? bitInfo.ShortName + '/USDT' : ''}}</span>
				<img :src="downUrl" class="pointer" alt=""  v-show="followList.length > 1" @click="changeBitType(0)">

				<div class="flex-column-center money">
					<div class="value" :class="bitInfo.percent > 0 ? 'green' : 'red'">{{bitInfo.count || '0.0000'}}</div>
					<div class="desc">{{resetBitMoney2(bitInfo.count)}}</div>
				</div>

				<div class="bit-info">
					<div class="label">{{ $t('24h-zhang-die-fu') }}</div>
					<div class="value" :class="bitInfo.percent > 0 ? 'green' : 'red'">{{bitInfo.percent > 0 ? '+' : ''}}{{bitInfo.percent}}%</div>
				</div>

				<div class="bit-info">
					<div class="label">{{ $t('24h-zui-gao-jia') }}</div>
					<div class="value" >{{tradeData.highest || '0.00'}}</div>
				</div>

				<div class="bit-info">
					<div class="label">{{ $t('24h-zui-di-jia') }}</div>
					<div class="value" >{{tradeData.lowest || '0.00'}}</div>
				</div>

				<div class="bit-info">
					<div class="label">{{ $t('24h-cheng-jiao-liang') }}（{{bitInfo.ShortName}}）</div>
					<div class="value" >{{parseFloat(tradeData.volume).toFixed(2) || '0.00'}}</div>
				</div>

				<div class="bit-info">
					<div class="label">{{ $t('24h-cheng-jiaoeusdt') }}</div>
					<div class="value" >{{parseFloat(tradeData.amount).toFixed(2) || '0.00'}}</div>
				</div>
			</div>
			<img :src="settingUrl" alt="">
		</div>

		<div class="center-main flex">
			<div class="left ">
				<div class="search-line">
					<Search v-model="keyword" right-icon="search" left-icon="" :clearable="false" :placeholder="$t('sou-suo-bi-zhong')"  @search="searchMarket" @input="searchMarket"></Search>
				</div>

				<div class="tags flex">
					<div class="tag active">USDT</div>
				</div>

				<div class="bit-list">
					<div class="list flex-center-between" v-for="(item, i) in showBitList" :key="i" @click="changeBit(item)">
						<div class="flex-center">
							<span class="sort">{{i + 1}}</span>
							<img :class="item.ShortName === 'BAL' ? 'bg' : ''" :src="`/upload/${item.Logo}`" alt="">
							<span class="name" >{{item.ShortName}}/USDT</span>
							<Icon name="star" size="16" class="ml-10" color="#85898F" @click.stop="changeFollowStatus(0, item)"  v-if="bitIndex == 0"></Icon>
						</div>
						<div class="text-right">
							<div class="count">{{item.count || '0.00'}}</div>
							<div class="percent" :class="item.percent > 0 ? 'green' : 'red'">{{item.percent > 0 ? '+' : ''}}{{item.percent}}%</div>
						</div>
					</div>
				</div>
			</div>

			<div class="main flex-1">
				<div class="top-chart" :class="tabIndex == 0 ? 'big' : ''">
					<chart-page
						:id="bitInfo.ID"
						:showChart="true"
						:bitName="bitInfo.ShortName"
						:latest-price="currentPrice"
						:price-direction="priceDirection"
					></chart-page>
				</div>

				<!-- 现货交易组件 -->
				<spot-trade
					v-if="tabIndex == 0"
					:bit-info="bitInfo"
					:tab-index="tabIndex"
					:page-type="pageType"
					:is-login="isLogin"
					:user-money="userMoney"
					:user-bit-money="userBitMoney"
					:action-type="actionType"
					:transfer-url2="transferUrl2"
					:hide-balance="hideBalance"
					@change-action-type="changeActionType"
					@submit-spot="handleSpotSubmit"
					@to-transfer="toTransfer"
					@to-login="toLogin"
					@toggle-balance="toggleBalance"
				/>

				<!-- 合约交易组件 -->
				<contract-trade
					v-if="tabIndex == 1"
					:bit-info="bitInfo"
					:tab-index="tabIndex"
					:page-type="pageType"
					:is-login="isLogin"
					:user-contract-money="userContractMoney"
					:user-bit-contract-money="userBitContractMoney"
					:action-type="actionType"
					:transfer-url2="transferUrl2"
					:hide-balance="hideBalance"
					@change-action-type="changeActionType"
					@submit-contract="handleContractSubmit"
					@to-transfer="toTransfer"
					@to-login="toLogin"
					@toggle-balance="toggleBalance"
				/>

				<!-- 期权交易组件 -->
				<option-trade
					v-if="tabIndex == 2"
					:bit-info="bitInfo"
					:tab-index="tabIndex"
					:page-type="pageType"
					:is-login="isLogin"
					:user-option-money="userOptionMoney"
					:time-list="timeList"
					@submit-option="handleOptionSubmit"
					@to-login="toLogin"
				/>
			</div>
			<div class="right">
				<div class="title">{{ $t('ding-dan-biao') }}</div>
				<div class="flex-center-end deep-box">
					<a-select v-model="deepName" @change="changeDeep()" dropdownClassName="deep-select" class="deep">
						<img :src="downUrl" slot="suffixIcon" class="suffix-icon">
						<a-select-option v-for="(item, i) in deepList" :key="i" :value="item">{{item}}</a-select-option>
					</a-select>
				</div>

				<div class="price-list">
					<div class="th-line flex-center-between">
						<div class="th">{{i18n.t('trade.label15')}}</div>
						<div class="th">{{i18n.t('trade.label16')}}</div>
					</div>

					<div class="flex-center-between list" v-for="(item, i) in upDealList" :key="i" @click="checkPrice(item)">
						<div class="value red">{{item.value ? resetValue(item.value) : '--'}}</div>
						<div class="count">{{item.dealCount || '--'}}</div>
					</div>

					<div class="price flex-center-start" :class="`type${actionType}`">
						<div class="number" :class="bitInfo.percent > 0 ? 'green' : 'red'">{{bitInfo.count}}</div>
						<div class="small">≈{{resetBitMoney2(bitInfo.count)}} {{currencyVal}}</div>
					</div>

					<div class="flex-center-between list" v-for="(item, index) in downDealList" :key="'down' + index" @click="checkPrice(item)">
						<div class="value green">{{item.value ? resetValue(item.value) : '--'}}</div>
						<div class="count">{{item.dealCount || '--'}}</div>
					</div>

				</div>
			</div>
			<div class="right2">
				<div class="title">{{ $t('zui-xin-cheng-jiao') }}</div>
				<div class="trade-list">
					<div class="th-line flex-center">
						<div class="th flex-1">{{i18n.t('trade.label15')}}</div>
						<div class="th flex-1 text-right">{{i18n.t('trade.label16')}}</div>
						<div class="th flex-1 text-right">{{ $t('shi-jian') }}</div>
					</div>

					<div class="list flex-center" v-for="(item, i) in tradeLogList" :key="i">
						<div class="td flex-1" :class="item.type == 'Buy' ? 'green' : 'red'">{{resetValue(item.val)}}</div>
						<div class="td flex-1 text-right">{{item.dealCount}}</div>
						<div class="td flex-1 text-right">{{resetTime(item.time)}}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="bottom-main">
			<div class="tabs">
				<div class="tab" :class="orderTabIndex == 1 ? 'active' : ''" @click="changeOrderTab(1)">{{tabIndex == 2 ? i18n.t('trade.label50') : (tabIndex == 1 ? i18n.t('trade.label47') : i18n.t('trade.label46')) }}</div>
				<div class="tab" v-show="tabIndex == 0" :class="orderTabIndex == 2 ? 'active' : ''" @click="changeOrderTab(2)" >{{i18n.t('trade.label51')}}</div>
				<div class="tab" v-show="tabIndex == 2" :class="orderTabIndex == 3 ? 'active' : ''" @click="changeOrderTab(3)" >{{ $t('li-shi-ding-dan') }}</div>
			</div>

			<!--现货-->
			<div class="order-list" v-if="tabIndex == 0">
				<div v-if="orderTabIndex == 1">
					<div class="th-line flex-center-between" >
						<div class="th flex-2">{{ $t('jiao-yi-bi-zhong-1') }}</div>
						<div class="th flex-2">{{ $t('chi-cang-fang-xiang') }}</div>
						<div class="th flex-2">{{ $t('wei-tuo-lei-xing-0') }}</div>
						<div class="th flex-2">{{ $t('wei-tuo-shi-jian-0') }}</div>
						<div class="th flex-2">{{ $t('wei-tuo-zong-liang') }}</div>
						<div class="th flex-2">{{ $t('wei-tuo-jia-ge-0') }}</div>
						<div class="th action">{{ $t('cao-zuo-2') }}</div>
					</div>
					<div class="td-line flex-center-between" v-for="(item, i) in orderList" :key="i">
						<div class="td flex-center-start flex-2">
							<span>{{item.Currency.ShortName}}/USDT </span>
						</div>
						<div class="td flex-2">
							<span :class="item.Trade == 'buy' ? 'green' : 'red'">{{item.Trade == 'buy' ? i18n.t('trade.buy1') : i18n.t('trade.sell1')}}</span>
						</div>
						<div class="td flex-2">
							{{item.Trust == 'limit' ? i18n.t('trade.label53') : i18n.t('trade.label52')}}
						</div>
						<div class="td flex-2">
							<span>{{item.CreatedAt}}</span>
						</div>
						<div class="td flex-2">
							<span>{{item.TrustNum}}</span>
						</div>
						<div class="td flex-2" :class="item.Trade == 'buy' ? 'green' : 'red'">
							{{parseFloat(item.Close).toFixed(4)}}
						</div>
						<div class="td action">
							<div class="btn" @click="cancelOrder(item)">{{ $t('che-dan') }}</div>
						</div>
					</div>
				</div>


				<div v-if="orderTabIndex == 2">
						<div class="th-line flex-center-between" >
						<div class="th flex-2">{{ $t('jiao-yi-bi-zhong-1') }}</div>
						<div class="th flex-2">{{ $t('trade.label65') }}</div>
						<div class="th flex-2">{{ $t('trade.label66') }}</div>
						<div class="th action long">{{ $t('trade.label67') }}</div>
					</div>
					<div class="td-line flex-center-between" v-for="(item, i) in walletBitList" :key="i">
						<div class="td flex-center-start flex-2">
							<span>{{item.Currency.ShortName}}/USDT </span>
						</div>
						<div class="td flex-2">
							{{(parseFloat(item.SpotUse) + parseFloat(item.SpotFree)).toFixed(4)}}
						</div>
						<div class="td flex-2">
							{{(parseFloat(item.SpotFree)).toFixed(4)}}
						</div>
						<div class="td action long">
							{{(parseFloat(item.SpotUse)).toFixed(4)}}
						</div>
					</div>
				</div>
			</div>
			<!--合约-->
			<div class="order-list" v-if="tabIndex == 1">
				<div class="th-line flex-center-between" >
					<div class="th flex-2">{{ $t('jiao-yi-bi-zhong-fang-xiang-2') }}</div>
					<div class="th flex-2">{{ $t('lei-xing-0') }}</div>
					<div class="th flex-2">{{ $t('kai-cang-shi-jian-jia-ge') }}</div>
					<div class="th flex-2">{{ $t('biao-ji-jia-ge-chi-cang-liang') }}</div>
					<div class="th flex-2">{{ $t('shou-yi') }}</div>
					<div class="th flex-2">{{ $t('yu-ji-qiang-ping-cang-0') }}</div>
					<div class="th action">{{ $t('cao-zuo') }}</div>
				</div>
				<div class="td-line flex-center-between" v-for="(item, i) in contractOrderList" :key="i">
					<div class="td flex-center-start  flex-2">
						<div class="tab" :class="[item.Direction == 'long' ? 'green' : 'red', i18n.t('trade.label21').length > 12 ? 'small' : '']">{{item.Direction == 'long' ? i18n.t('trade.buy2') : i18n.t('trade.sell2')}}</div>
						<span>{{item.Currency.ShortName}}/USDT </span>
					</div>
					<div class="td  flex-2">
						{{item.Full == 'full' ? i18n.t('trade.label1') : i18n.t('trade.label2')}} {{item.Multiple}}X
					</div>
					<div class="td  flex-2 small" >
						<div class="gray">{{formatOpenTime(item.CreatedAt)}}</div>
						<div :class="item.Direction == 'long' ? 'green' : 'red'">{{parseFloat(item.OpenClose).toFixed(4)}}</div>
					</div>
					<div class="td  flex-2 small">
						<div class="gray">{{parseFloat(item.TrustClose).toFixed(4)}}</div>
						<div :class="item.Direction == 'long' ? 'green' : 'red'">{{item.OpenNum}}</div>
					</div>
					<div class="td  flex-2">
						<span>{{getContractProfit(item.OpenClose, item.Multiple, item.Direction, item.OpenNum)}}</span>
					</div>
					<div class="td  flex-2">
						{{getContractClose(item.OpenClose, item.Multiple, item.Direction)}}
					</div>
					<div class="td action">
						<!-- <div class="btn " @click.stop="setWinOrLose(item)">{{$t('trade.label11')}}</div> -->
						<div class="btn" @click.stop="toClearOrder(item)">{{i18n.t('trade.status5')}}</div>
					</div>
				</div>
			</div>

			<!--期权-->
			<div class="order-list" v-if="tabIndex == 2">
				<!-- 当前订单 -->
				<div v-if="orderTabIndex == 1">
					<div class="th-line flex-center-between" >
						<div class="th flex-2">{{ $t('jiao-yi-bi-zhong-2') }}</div>
						<div class="th flex-2">{{ $t('chi-cang-fang-xiang-0') }}</div>
						<div class="th flex-2">{{ $t('kai-cang-shi-jian-jia-ge-0') }}</div>
						<div class="th flex-2">{{ $t('xia-dan-jin-e') }}</div>
						<div class="th flex-2">{{ $t('shi-jian-0') }}</div>
						<div class="th flex-2">{{ $t('jiao-ge-shi-jian-jia-ge') }}</div>
						<div class="th flex-2">{{ $t('ying-kui') }}</div>
						<div class="th action">{{ $t('zhuang-tai-0') }}</div>
					</div>
					<div class="td-line flex-center-between" v-for="(item, i) in optionOrderArr" :key="i" :class="{ 'retained-order': isRetainedOrder(item.ID) }">
						<div class="td flex-center-start  flex-2">
							<span>{{item.Currency.ShortName}}/USDT </span>
						</div>
						<div class="td  flex-2">
							<span  :class="item.Direction == 'rose' ? 'green' : 'red'">{{item.Direction == 'rose' ? i18n.t('trade.buy3') : i18n.t('trade.sell3')}}</span>
						</div>
						<div class="td  flex-2 small">
							<div class="gray">{{formatOpenTime(item.CreatedAt)}}</div>
							<div :class="item.Direction == 'rose' ? 'green' : 'red'">{{parseFloat(item.MarkPrice).toFixed(4)}}</div>
						</div>
						<div class="td flex-2">
							{{parseFloat(item.Amount).toFixed(4)}}
						</div>
						<div class="td  flex-2">
							<template v-if="item.Status == 0">
								{{getCountdownTime(item)}}
							</template>
							<template v-else>
								{{item.Settlement}}S
							</template>
						</div>
						<div class="td  flex-2 small">
							<div class="gray">{{formatSettlementTime(item.SettlementTime)}}</div>
							<div :class="item.Direction == 'rose' ? 'green' : 'red'">{{parseFloat(item.SettlementPrice).toFixed(4)}}</div>
						</div>
						<div class="td  flex-2">
							{{parseFloat(item.Profit).toFixed(4)}}
						</div>
						<div class="td action">
							{{item.Status == 0 ? i18n.t('trade.status6') : (item.Status == 1 ? i18n.t('trade.status7') : i18n.t('trade.status8'))}}
						</div>
					</div>
				</div>

				<!-- 历史订单 -->
				<div v-if="orderTabIndex == 3">
					<div class="th-line flex-center-between" >
						<div class="th flex-2">{{ $t('jiao-yi-bi-zhong-2') }}</div>
						<div class="th flex-2">{{ $t('chi-cang-fang-xiang-0') }}</div>
						<div class="th flex-2">{{ $t('kai-cang-shi-jian-jia-ge-0') }}</div>
						<div class="th flex-2">{{ $t('xia-dan-jin-e') }}</div>
						<div class="th flex-2">{{ $t('shi-jian-0') }}</div>
						<div class="th flex-2">{{ $t('jiao-ge-shi-jian-jia-ge') }}</div>
						<div class="th flex-2">{{ $t('ying-kui') }}</div>
						<div class="th action">{{ $t('zhuang-tai-0') }}</div>
					</div>
					<div class="td-line flex-center-between" v-for="(item, i) in historyOptionOrderArr" :key="'history' + i">
						<div class="td flex-center-start  flex-2">
							<span>{{item.Currency.ShortName}}/USDT </span>
						</div>
						<div class="td  flex-2">
							<span  :class="item.Direction == 'rose' ? 'green' : 'red'">{{item.Direction == 'rose' ? i18n.t('trade.buy3') : i18n.t('trade.sell3')}}</span>
						</div>
						<div class="td  flex-2 small">
							<div class="gray">{{formatOpenTime(item.CreatedAt)}}</div>
							<div :class="item.Direction == 'rose' ? 'green' : 'red'">{{parseFloat(item.MarkPrice).toFixed(4)}}</div>
						</div>
						<div class="td flex-2">
							{{parseFloat(item.Amount).toFixed(4)}}
						</div>
						<div class="td  flex-2">
							{{item.Settlement}}S
						</div>
						<div class="td  flex-2 small">
							<div class="gray">{{formatSettlementTime(item.SettlementTime)}}</div>
							<div :class="item.Direction == 'rose' ? 'green' : 'red'">{{parseFloat(item.SettlementPrice).toFixed(4)}}</div>
						</div>
						<div class="td  flex-2">
							{{parseFloat(item.Profit).toFixed(4)}}
						</div>
						<div class="td action">
							{{item.Status == 1 ? i18n.t('trade.status7') : i18n.t('trade.status8')}}
						</div>
					</div>
				</div>
			</div>
		</div>


		<!--二次确认弹框-->

		<div class="page-modal trade small" v-show="showEnsureModal">
			<div class="">
				<div class="title flex-center-between">
					<div>{{$t('common.ensure')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>

				<div class="content">
					<div>{{$t('trade.desc33')}}</div>
				</div>

				<div class="flex btn mt-15">
					<Button class="gray" @click="cancel">{{i18n.t('trade.btn1')}}</Button>
					<Button @click="ensureAction">{{i18n.t('trade.btn2')}}</Button>
				</div>
			</div>
		</div>

		<!--平仓-->
		<Popup v-model:show="showClearPage" position="bottom" lock-scroll class="rate-popup">
			<clear-page :bitInfo="bitInfo" :orderData="orderdetailData" @cancel="cancel" @submit="submitClear"></clear-page>
		</Popup>

		<!--下单确认-->
		<div class="page-modal trade" v-show="showConfirmModal">
			<div class="">
				<div class="title flex-center-between">
					<div>{{$t('trade.label48')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>

				<div class="sub-title">
					<div class="flex-center-start">
						<span class="name">{{bitInfo.ShortName}}/USDT</span>
						<span :class="tradeType == 'buy' ? 'green' : 'red'" v-if="ensureType == 'spot'">
							{{i18n.t(`trade.tab${actionType}`)}}
							{{tradeType == 'buy' ? i18n.t('trade.buy1') : i18n.t('trade.sell1')}}
						</span>
						<span :class="ensureData.type == 'long' ? 'green' : 'red'" v-if="ensureType == 'contract'">
							{{i18n.t(`trade.tab${actionType}`)}}
							{{ensureData.type == 'long' ? i18n.t('trade.buy2') : i18n.t('trade.sell2')}}
						</span>
						<span :class="tradeType == 'buy' ? 'green' : 'red'" v-if="ensureType == 'option'">
							{{tradeType == 'buy' ? i18n.t('trade.buy3') : i18n.t('trade.sell3')}}
						</span>

					</div>
				</div>

				<div class="flex-wrap info-box">
					<div class="info-line " v-if="ensureType == 'spot' && actionType == 3">
						<div>{{i18n.t('trade.label5')}}</div>
						<div class="value">{{form.stopPrice}} USDT</div>
					</div>
					<div class="info-line "  v-if="ensureType != 'option'">
						<div>{{i18n.t(`trade.label4`)}}</div>
						<div class="green value">{{ensureData.close}} USDT</div>
					</div>
					<div class="info-line " v-if="ensureType == 'spot' || ensureType == 'contract'">
						<div>{{i18n.t('trade.label42')}}</div>
						<div class="value">{{ensureData.number}} {{bitInfo.ShortName}}</div>
					</div>
					<div class="info-line "  v-if="ensureType == 'contract'">
						<div>{{i18n.t('trade.label8')}}</div>
						<div class="value">{{ ensureData.total}} USDT</div>
					</div>
					<div class="info-line " v-if="ensureType == 'contract'">
						<div>{{i18n.t('trade.label43')}}</div>
						<div class="value">{{multForm.fullType == 'full' ? i18n.t('trade.label1') : i18n.t('trade.label2')}} {{multForm.multiple}}X</div>
					</div>
					<div class="info-line " v-if="ensureType == 'contract'">
						<div>{{i18n.t('trade.label24')}}</div>
						<div class="value">{{ensureData.takeProfit || '- -'}}</div>
					</div>
					<div class="info-line " v-if="ensureType == 'contract'">
						<div>{{i18n.t('trade.label27')}}</div>
						<div class="value">{{ensureData.stopLoss || '- -'}}</div>
					</div>
					<div class="info-line " v-if="ensureType == 'contract'">
						<div>{{i18n.t('trade.th12')}}</div>
						<div class="yellow value">{{getContractClose(ensureData.close, multForm.multiple, ensureData.type)}} USDT</div>
					</div>
					<div class="info-line " v-if="ensureType == 'option'">
						<div>{{i18n.t('trade.label55')}}</div>
						<div class="value">{{ensureData.typeName}}</div>
					</div>
					<div class="info-line " v-if="ensureType == 'option'">
						<div>{{i18n.t('trade.label56')}}</div>
						<div class="value">{{ensureData.money}}USDT</div>
					</div>
					<div class="info-line " v-if="ensureType == 'option'">
						<div>{{i18n.t('trade.label57')}}</div>
						<div class="value">{{ensureData.profit}}USDT</div>
					</div>
				</div>


				<div class="flex btn mt-15">
					<Button class="gray" @click="cancel">{{$t('common.cancel')}}</Button>
					<Button :loading="orderLoading" v-if="ensureType == 'spot'" class="black"  @click="ensureSubmit">{{ensureData.type == 'buy' ? i18n.t('trade.buy1') : i18n.t('trade.sell1')}} {{bitInfo.ShortName}}</Button>
					<Button :loading="orderLoading"  v-if="ensureType == 'contract'"  class="black"  @click="ensureSubmit">{{i18n.t('common.ensure')}}</Button>
					<Button :loading="orderLoading"  v-if="ensureType == 'option'"  class="black"  @click="ensureSubmit">{{i18n.t('common.ensure')}}</Button>
				</div>
			</div>
    </div>
  </div>
</template>

<script>
import { Button, Search, List, Slider, Popup, Picker, Checkbox, Icon } from 'vant';
import chartPage from './chart'
import bitPage from '@/components/bit'
import clearPage from './clear'
import spotTrade from './components/spot-trade'
import contractTrade from './components/contract-trade'
import optionTrade from './components/option-trade'
import { initWebSocket } from '@/utils/common'
import { getToken } from '@/utils/auth'
import { getCoinList, monetaryList } from '@/api/index'
import { userInfo } from '@/api/user'
import { wallet, allTrades, ImitateWallet } from '@/api/assest'
import { spotBuy, futuresSetting, optionOrder, imitateOptionOrder, optionOrderList, imitateOptionOrderList,
				spotList, cancelSpotOrder, cancelContractOrder, traderOverview, bitFollowList, bitFollowAdd, bitFollowRemove,
				cancelImitateContractOrder, contractOrder, imitateContractOrder, contractList, imitateContractList,
				tradeHistory, contractSpot, imitateContractSpot, contractLiquidation, imitateContractLiquidation, tradeSetting, updateTradeSetting, getTradeCache } from '@/api/trade'
import moment from 'moment';
require('moment-timezone');
import { formatServerTimeEn, getServerNow } from '@/utils/timeUtils'
export default {
  name: 'about',
  components: {
    Button,
    Search,
    List,
		Icon,
		Slider,
		Popup,
		Picker,
		Checkbox,
		bitPage,
		chartPage,
		clearPage,
		spotTrade,
		contractTrade,
		optionTrade
  },
	props: {
		modalType: [String, Number]
	},
	computed: {
		loginStatus() {
      return this.$store.state.isLogin
    },
		buyCount() {
			if (this.bitInfo && this.bitInfo.count) {
				if (this.tabIndex == 0) {
					return (parseFloat(this.userMoney) / parseFloat(this.bitInfo.count)).toFixed(4)
				} else {
					return (parseFloat(this.userContractMoney) / parseFloat(this.bitInfo.count)).toFixed(4)
				}
			} else {
				return ''
			}
		},
		currencyVal() {
      return this.$store.state.currencyVal
    },
		saleCount() {
			if (this.bitInfo.count) {
				if (this.tabIndex == 0) {
					return (parseFloat(this.userBitMoney) * parseFloat(this.bitInfo.count)).toFixed(4)
				} else {
					return (parseFloat(this.userBitContractMoney) * parseFloat(this.bitInfo.count)).toFixed(4)
				}
			} else {
				return ''
			}
		},
		profitMoney() {
			if (!this.upDownForm.money) {
				return '0.0000'
			} else {
				return (this.upDownForm.money * this.upDownForm.percent / 100).toFixed(4)
			}
		},
		profitMoney2() {
			if (!this.upDownForm.money2) {
				return '0.0000'
			} else {
				return (this.upDownForm.money2 * this.upDownForm.percent2 / 100).toFixed(4)
			}
		},
		isSend() {
      return this.$store.state.isSend
    },
		bitList() {
			return this.$store.state.bitList.filter(v => {
				return v.ShortName != 'USDT'
			})
		},
		isFollow() {
			return this.followList.findIndex(v => {
				return v.CurrencyID === this.bitInfo.ID
			}) > -1
		},
		showBitList() {
			if (this.bitIndex == 1) {
				return this.marketList
			} else {
				return this.marketList.filter(v => {
					return this.followList.findIndex(val => {
						return v.ID == val.CurrencyID
					}) > -1
				})
			}
		},
		tradeLogList() {
			if (this.tradeDataBak.length <= 37) {
				return [].concat(this.tradeDataBak)
			} else {
				return this.tradeDataBak.slice(this.tradeDataBak.length - 37)
			}
		}
	},
  data() {
    return {
			form: {
				triggerType: 1,
				triggerTypeName: this.i18n.t('trade.label25'),
				limitType: 1,
				limitTypeName: this.i18n.t('trade.label22'),
				setting1: false,
				setting2: false,
				number: '',
				number2: '',
				totalMoney: '',
				stopName: this.i18n.t('trade.label24'),
				stop: '1',
				stopPrice: '',
				stopPrice2: '',
			},
			hideBalance: false, // 余额隐藏状态
			isModal: false,
			orderLoading: false,
			keyword: '',
			pageType: -1,
			newestMoney: 0,
			winForm: {
				tradeType: 'buy',
				winMoney: '',
				loseMoney: '',
				winMoney2: '',
				loseMoney2: '',
				winPercent: 10,
				losePercent: 10
			},
			upDownForm: {
				time: '',
				percent: '',
				money: '',
				time2: '',
				percent2: '',
				money2: '',
			},
			multForm: {
				fullType: 'full',
				multiple: 10,
			},
			multList: [10, 20, 50, 100, 200],
			userMoney: '0.0000',
			userContractMoney: '0.0000',
			userOptionMoney: '0.0000',
			userBitMoney: '0.0000',
			userBitContractMoney: '0.0000',
			userBitOptionMoney: '0.0000',
			percentList: [10, 20, 50, 100, 150],
			losePercentList: [10, 20, 30, 50, 90],
			bitUrl: require('../../assets/imgs/bit4.png'),
			starUrl: require('../../assets/imgs/icon-star.png'),
			settingUrl: require('../../assets/imgs/icon-setting.png'),
			downUrl: require('../../assets/imgs/icon-arrow-down2.png'),
			closeUrl: require('../../assets/imgs/icon-close.png'),
			emptyUrl: require('../../assets/imgs/empty.png'),
			transferUrl2: require('../../assets/imgs/icon-transfer3.png'),
			tradeType: 'buy', // 买入、卖出
			actionTypeName: this.i18n.t('trade.tab1'), // 交易方式
			actionType: 1,
			tradeMoney: '',//订单买入价格
			tradeMoney2: '',//订单卖出价格
			moneySpace: 0.01, // 每次增减金额
			maxSize: 2, // 订单价格小数最大位数
			inputActive: false,
			inputActive2: false,
			inputActive3: false,
			inputActive4: false,
			inputActive5: false,
			inputActive6: false,
			inputActive7: false,
			inputActive8: false,
			actionTypeList: [
				{
					value: 1,
					text: this.i18n.t('trade.type1')
				},
				{
					value: 2,
					text: this.i18n.t('trade.type2')
				},
				{
					value: 3,
					text: this.i18n.t('trade.type3')
				},
			],
			multipleList: [10, 20, 50, 100, 200],
			bitInfo: {
				ShortName: 'BTC',
				ID: '1',
				percent: 0,
				count: ''
			},
			tradeMoneyPercent: 0,
			tradeMoneyPercent2: 0,
			tabIndex: 0,
			cancelEnsure: false,
			showDefault: true,
			showPercent: false,
			showPercent2: false,
			showMultiplePercent: false,
			showWinPercent: false,
			showLosePercent: false,
			multiplePercent: 0,
			winPercent: 0,
			losePercent: 0,
			showPickerModal: false,
			showPickerModal2: false,
			showPickerModal3: false,
			showMoreModal: false,
			showUpDownPopup: false,
			showMultModal: false,
			showEnsureModal: false,
			ensureType: '',
			ensureParam: '',
			pickerTop: 0,
			pickerTop2: 0,
			pickerTop3: 0,
			moreTop: 0,
			layout: 0,
			upDealList: [],
      upDealListBak: [],
			allUpDealList: [],
      downDealList: [],
      downDealListBak: [],
			allDownDealList: [],
			deepName: 0.001,// 展示深度
			deepType: 1, // 展示方式
			afterSize: 3, // 展示价格小数位数
			maxValue: 1400, // 展示数量最大值
			minValue: 500, // 展示数量最小值
			deepList: [1, 0.1, 0.01, 0.001],
			showPopup: false,
			pickerType: '',
			orderTabIndex: 1,
			showAll: false,
			showSetting: false,
			showAllOrder: false,
			showRate: false,
			showBit: false,
			showWinSetting: false,
			showWinInfo: false,
			showWinDesc: false,
			showConfirmModal: false,
			upDownType: '',
			timeList: [],
			client: null, // ws链接client, 内含多个ws连接
			webSocket: null, // 币种价格行情ws
			tradeWs: {}, // 单个币种交易量ws
			futuresObj: {},
			futuresObj2: {},
			orderList: [],
			contractOrderList: [],
			optionOrderArr: [],
			historyOptionOrderArr: [], // 历史期权订单数组
			retainedOrderIds: [], // 需要保留在当前订单中的已结算订单ID列表
			retainedOrderTimestamps: {}, // 记录订单保留的时间戳
			isOrderEnsure: true,
			isCancelOrderEnsure: true,
			isSpotEnsure: true, // 现货下单确认
			isOptionEnsure: true, // 期权下单确认
			isContractEnsure: true, // 合约下单确认
			isImitateEnsure: true, // 模拟下单确认
			tradeDataBak: [], // 存放临时交易数据
			timer: '',
			isInitTrade: false, // 防止接口过慢
			isLogin: true,
			setDeep: false,
			upPercentList: [],
			downPercentList: [],
			walletBitList: [],
			allTradesData: [],
			orderTimer: '',
			showClearPage: false,
			orderdetailData: {},
			ensureForm: null,
			ensureData: {},
			marketList: [],
			tradeSettingData: {},
			allRateList: [],
			tradeData: {
				lowest: 0,
				highest: 0,
				volume: 0,
				amount: 0,
			},
			followList: [],
			bitIndex: 1,
			actionDirection: null,
			countdownTimer: null, // 倒计时定时器
			// 添加价格追踪变量
			lastPrice: 0,  // 上一次的价格
			currentPrice: 0, // 当前价格
			priceDirection: 0, // 价格方向：1=上涨, -1=下跌, 0=无变化
			// 订单重试机制相关
			lastCreatedOrderId: null, // 最后创建的订单ID
			orderRetryCount: 0, // 订单重试次数
			orderRetryCount: 0, // 订单重试次数
			maxRetryCount: 3, // 最大重试次数
			balanceTimer: null,
    }
  },
	beforeDestroy() {
    this.$store.state.isSend = false
		if (this.webSocket && this.webSocket.close) {
			this.$store.state.isClose = true
      this.webSocket.close()
    }
		clearInterval(this.timer)
		clearInterval(this.balanceTimer)
		clearTimeout(this.orderTimer)
		clearInterval(this.countdownTimer) // 清除倒计时定时器
		// 清理保留订单数据
		this.retainedOrderIds = []
		this.retainedOrderTimestamps = {}
  },
	watch: {
		'$route'() {
			this.initQuery()
		},
		modalType(val) {
			if (val) {
				this.initType()
			}
		},
		loginStatus() {
      this.isLogin = !!getToken()
    },
	},
  mounted() {
		this.initQuery()
		this.isLogin = !!getToken()
		let list = localStorage.getItem('bitList')
		if (list && list != 'undefined' && this.bitList.length == 0) {
			this.$store.state.bitList = JSON.parse(list)
		}
		if (this.bitList.length > 0) {
			this.marketList = [].concat(this.bitList).slice(0, 13)
		}
		if (this.modalType) {
			this.isModal = true
			this.initType()
		}
		this.initAllTrade()
		this.initSocket()
		this.init()
		this.initTrade()

		this.initFuture()
		this.initOrder()

		this.initConfirm()

		this.initRate()

		//24h交易概况
		this.initTradeStatistics()
		// 关注
		if (this.isLogin) {
			this.initFollow()
		}
		this.startBalanceTimer()
  },
  methods: {
		initType() { // 切换模拟交易类型
			if (this.modalType == 1) {
				this.tabIndex = 2
			} else if (this.modalType == 2) {
				this.tabIndex = 1
			}
			this.initWallet()
		},
		initRate() {
			monetaryList().then(res => {
				this.allRateList = res.data.Items
			})
		},
		initQuery() {
			let type = this.$route.query.type
			let imitateType = this.$route.query.imitateType
			this.pageType = type ? parseInt(type) : parseInt(imitateType) + 3
			switch(this.pageType) {
				case 1: this.tabIndex = 0; break;
				case 2: this.tabIndex = 2; break;
				case 3: this.tabIndex = 1; break;
				case 4: this.tabIndex = 2; break;
				case 5: this.tabIndex = 1; break;
				default: break
			}
			let name = this.$route.query.name
			if (name) {
				this.bitInfo.ShortName = name
				this.bitInfo.ID = this.$route.query.id
				console.log("this.bitInfo")
				console.log(this.bitInfo)
			}
		},
		init() {
			if (this.bitList.length == 0) {
				getCoinList().then(res => {
					let bitListBak = res.data.Items
					this.$store.state.bitList = [].concat(bitListBak)
					localStorage.setItem('bitList', JSON.stringify(bitListBak))
					this.marketList = [].concat(bitListBak).slice(0, 13)

					// 确保 bitInfo 初始化
					if (this.bitInfo.ShortName) {
						let index = this.bitList.findIndex(v => {
							return v.ShortName == this.bitInfo.ShortName
						})
						if (index > -1) {
							this.bitInfo = this.bitList[index]
							this.tradeMoney = this.bitInfo.count
							this.tradeMoney2 = this.bitInfo.count
							// 设置初始价格
							this.currentPrice = parseFloat(this.bitInfo.count) || 0
							this.lastPrice = this.currentPrice
						} else if (this.bitList.length > 0) {
							// 如果找不到匹配的币种，默认使用第一个
							this.bitInfo = this.bitList[0]
							this.tradeMoney = this.bitInfo.count
							this.tradeMoney2 = this.bitInfo.count
							// 设置初始价格
							this.currentPrice = parseFloat(this.bitInfo.count) || 0
							this.lastPrice = this.currentPrice
						}
					} else if (this.bitList.length > 0) {
						// 如果 bitInfo 没有 ShortName，默认使用第一个
						this.bitInfo = this.bitList[0]
						this.tradeMoney = this.bitInfo.count
						this.tradeMoney2 = this.bitInfo.count
						// 设置初始价格
						this.currentPrice = parseFloat(this.bitInfo.count) || 0
						this.lastPrice = this.currentPrice
					}
				})
			} else {
				let index = this.bitList.findIndex(v => {
					return v.ShortName == this.bitInfo.ShortName
				})
				if (index > -1) {
					this.bitInfo = this.bitList[index]
					this.tradeMoney = this.bitInfo.count
					this.tradeMoney2 = this.bitInfo.count
				} else if (this.bitList.length > 0) {
					// 如果找不到匹配的币种，默认使用第一个
					this.bitInfo = this.bitList[0]
					this.tradeMoney = this.bitInfo.count
					this.tradeMoney2 = this.bitInfo.count
					// 设置初始价格
					this.currentPrice = parseFloat(this.bitInfo.count) || 0
					this.lastPrice = this.currentPrice
				}
			}
			//用户余额
			this.initWallet()
			this.initBitMoney()
		},
		initConfirm() {
			if (!this.isLogin) {
				return
			}
			tradeSetting().then(res => {
				let data = res.data.Items[0] || {}
				this.tradeSettingData = data
				this.isOptionEnsure = data.OptionOrderConfirm == 1 ? true : false
				this.isContractEnsure = data.FutureOrderConfirm == 1 ? true : false
				this.isSpotEnsure = data.SpotOrderConfirm == 1 ? true : false
				this.isImitateEnsure = data.SimulationOrderConfirm == 1 ? true : false
			})
		},
		initAllTrade() {
      allTrades().then(res => {
        this.allTradesData = res.data
      })
    },
		initWallet() {
			if (getToken()) {
				if (this.tradeType == 'buy') {
					let form = new FormData()
					form.append('current', 1)
					form.append('pageSize', 10)
					form.append('ShortName', 'usdt')
					if (this.modalType) {// 模拟钱包
						ImitateWallet(form).then(res => {
							let data = res.data.Items[0]
							if (data) {
								this.userMoney = data.SpotUse
								this.userOptionMoney = data.OptionUse
								this.userContractMoney = data.ContractUse
							}
						})
					} else {
						wallet(form).then(res => {
							let data = res.data.Items[0]
							if (data) {
								this.userMoney = data.SpotUse
								this.userOptionMoney = data.OptionUse
								this.userContractMoney = data.ContractUse

							}
						})
					}

				} else {
					this.initBitMoney()
				}
			}
		},
		initBitMoney() {
			if (!this.isLogin) {
				return
			}
			let form = new FormData()
			form.append('ShortName',  this.bitInfo.ShortName)
			form.append('current', 1)
			form.append('pageSize', 10)
			if (this.modalType) {// 模拟钱包
				ImitateWallet(form).then(res => {
					let data = res.data.Items[0]
					this.walletBitList =  res.data.Items
					if (data) {
						this.userBitMoney = data.SpotUse
						this.userBitOptionMoney = data.OptionUse
						this.userBitContractMoney = data.ContractUse
					}
				})
			} else {
				wallet(form).then(res => {
					let data = res.data.Items[0]
					this.walletBitList =  res.data.Items
					if (data) {
						this.userBitMoney = data.SpotUse
						this.userBitOptionMoney = data.OptionUse
						this.userBitContractMoney = data.ContractUse
					}
				})
			}
		},
		initTrade() {
			// 使用新的缓存接口替换原有的 tradeHistory 接口
			getTradeCache(this.bitInfo.ID).then(res => {
				if (res.data) {
					this.isInitTrade = true
					this.initDealListBak(res.data)
					// 初始化最新交易历史数据
					this.initLatestTransaction(res.data)
				}
			})
		},
		initLatestTransaction(data) {
			// 清空现有的历史数据，只保留 WebSocket 实时数据
			// 注意：不要直接清空 tradeDataBak，因为可能已经有实时数据
			let realtimeData = this.tradeDataBak.filter(item => {
				// 保留最近5分钟内的实时数据
				return (getServerNow().valueOf() - item.time) < (5 * 60 * 1000)
			})

			// 将买入和卖出数据合并并按时间排序
			let historicalData = []

			// 添加买入数据
			if (data.buy && data.buy.length > 0) {
				data.buy.forEach(trade => {
					historicalData.push({
						value: trade.Price,
						val: parseFloat(trade.Price),
						dealCount: this.resetCount(parseFloat(trade.Amount)),
						count: parseFloat(trade.Amount),
						time: moment.tz(trade.CreatedAt, this.$store.state.timeZone || 'Asia/Shanghai').valueOf(), // 使用服务端时区时间
						type: 'Buy'
					})
				})
			}

			// 添加卖出数据
			if (data.sell && data.sell.length > 0) {
				data.sell.forEach(trade => {
					historicalData.push({
						value: trade.Price,
						val: parseFloat(trade.Price),
						dealCount: this.resetCount(parseFloat(trade.Amount)),
						count: parseFloat(trade.Amount),
						time: moment.tz(trade.CreatedAt, this.$store.state.timeZone || 'Asia/Shanghai').valueOf(), // 使用服务端时区时间
						type: 'Sell'
					})
				})
			}

			// 按时间降序排序（最新的在前）
			historicalData.sort((a, b) => b.time - a.time)

			// 合并历史数据和实时数据，去除重复（以时间和价格为准）
			let allData = []

			// 先添加实时数据
			realtimeData.forEach(item => {
				allData.push(item)
			})

			// 再添加历史数据，避免重复
			historicalData.forEach(histItem => {
				let exists = allData.some(item => {
					// 如果时间差小于1秒且价格相同，认为是重复数据
					return Math.abs(item.time - histItem.time) < 1000 &&
						   Math.abs(parseFloat(item.value) - parseFloat(histItem.value)) < 0.00000001
				})

				if (!exists) {
					allData.push(histItem)
				}
			})

			// 再次按时间降序排序
			allData.sort((a, b) => b.time - a.time)

			// 只保留最近的60条记录作为初始化数据
			this.tradeDataBak = allData.slice(0, 60)

			console.log(`初始化最新交易数据完成: 历史数据${historicalData.length}条，实时数据${realtimeData.length}条，合并后${this.tradeDataBak.length}条`)
		},
		initFuture() {
			futuresSetting().then(res => {
				this.timeList = res.data.Items
				let data = this.timeList[0]
				if (data) {
					this.futuresObj = data
					this.upDownForm.time = data.Time
					this.upDownForm.percent = data.ProfitRatio

					this.futuresObj2 = data
					this.upDownForm.time2 = data.Time
					this.upDownForm.percent2 = data.ProfitRatio
				}
			})
		},
		initTradeStatistics() {
			let form = new FormData()
			form.append('ID', this.bitInfo.ID)
      if(getToken()) {
        traderOverview(form).then(res => {
          this.tradeData = res.data || {}
        })
      }

		},
		initFollow() {
			bitFollowList().then(res => {
				this.followList = res.data.Items || []
			})
		},
		changeFollowStatus(type, data) {
			let form = new FormData()

			if (type == 1) { // 添加
				form.append('CurrencyID', this.bitInfo.ID)
				bitFollowAdd(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.$t('trade.success5'))
						this.initFollow()
					} else {
						this.$taost.fail(res.msg)
					}
				})
			} else {
				if (data) {
					form.append('ID', data.ID)
				} else {
					form.append('ID', this.bitInfo.ID)
				}
				bitFollowRemove(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.$t('trade.success6'))
						this.initFollow()
					} else {
						this.$taost.fail(res.msg)
					}
				})
			}

		},
		changeBitType(type) {
			this.bitIndex = type
		},
		initOrder() {
			if (!getToken()) {
				return
			}
			clearTimeout(this.orderTimer)

			let form = new FormData()
			form.append('current', 1)
			form.append('pageSize', 20)
			if (this.tabIndex == 0) {
				form.append('Status', '1')
				spotList(form).then(res => {
					this.orderList = res.data.Items
					this.orderTimer = setTimeout(() => {
						this.initOrder()
					}, 3000)
				})
			} else if (this.tabIndex == 1) {
				form.append('Status', '0,1')
				if (this.isModal) {
					imitateContractList(form).then(res => {
						this.contractOrderList = res.data.Items
						this.orderTimer = setTimeout(() => {
							this.initOrder()
						}, 3000)
					})
				} else {
					contractList(form).then(res => {
						this.contractOrderList = res.data.Items
						this.orderTimer = setTimeout(() => {
							this.initOrder()
						}, 3000)
					})
				}
			} else if (this.tabIndex == 2) {
				// 当前(进行中)期权订单：不再按"客户端推算的当天时间窗口(Start/End)"过滤。
				// 原因：Start/End 由前端用 getServerNow() 推算的"服务器时区"生成，一旦该时区/时钟与服务端真实落库时区(created_at)不一致，
				//       窗口会整体偏移数小时，把刚下的单挡在窗口外，导致"下单后看不到记录"(线上偶发、本地难复现)。
				// 方案：与现货/合约一致，当前订单只按状态筛选——服务端按 id desc 返回(最新下单必在首页)，
				//       进行中订单由下方 Status==0 过滤决定，已结算订单由 retainedOrderIds 保留逻辑短暂展示。
				if (this.isModal) {
					imitateOptionOrderList(form).then(res => {
						// 检测订单状态变化，如果从Status == 0变成其他状态，添加到保留列表
						this.detectOrderStatusChange(res.data.Items)
						
						// 显示当前进行中的订单（Status == 0）以及需要保留的已结算订单
						this.optionOrderArr = res.data.Items.filter(item => {
							return item.Status == 0 || this.retainedOrderIds.includes(item.ID)
						})
						
						// 清理过期的保留订单（5分钟后自动移除）
						this.cleanExpiredRetainedOrders()
						
						// 调试信息
						console.log(`期权订单更新: 总计${res.data.Items.length}个，当前显示${this.optionOrderArr.length}个，保留${this.retainedOrderIds.length}个已结算订单`)
						if (this.retainedOrderIds.length > 0) {
							console.log('保留的订单ID:', this.retainedOrderIds)
						}
						
						// 移除时间转换逻辑，直接使用接口返回的原始SettlementTime数据
						this.startCountdownTimer() // 启动倒计时定时器
						this.orderTimer = setTimeout(() => {
							this.initOrder()
						}, 3000)
					})
				} else {
					optionOrderList(form).then(res => {
						// 检测订单状态变化，如果从Status == 0变成其他状态，添加到保留列表
						this.detectOrderStatusChange(res.data.Items)
						
						// 显示当前进行中的订单（Status == 0）以及需要保留的已结算订单
						this.optionOrderArr = res.data.Items.filter(item => {
							return item.Status == 0 || this.retainedOrderIds.includes(item.ID)
						})
						
						// 清理过期的保留订单（5分钟后自动移除）
						this.cleanExpiredRetainedOrders()
						
						// 移除时间转换逻辑，直接使用接口返回的原始SettlementTime数据
						this.startCountdownTimer() // 启动倒计时定时器
						this.orderTimer = setTimeout(() => {
							this.initOrder()
						}, 3000)
					})
				}
			}
		},
		async initSocket(){ //初始化weosocket
      let client = await initWebSocket('all', this.websocketonmessage)
			this.client = client
      this.webSocket = client.ws
			// 订阅交易量数据
			if (this.bitInfo && this.bitInfo.ShortName) {
				this.tradeWs = this.client.subscribe('/queue/' + this.bitInfo.ShortName.toUpperCase() + '-USDT-trades', message => {
					this.websocketonmessage({
						data: message.body
					});
				})
			}
    },
		websocketonmessage(e){ //数据接收
      let redata = {}
      try {
        redata = JSON.parse(e.data)
        this.setListData(redata)
      } catch(e) {
      }
    },
		setListData(data) {
			let Amount = data.fields.Amount
			if (!Amount) { //行情
				let index = this.bitList.findIndex(v => {
					return v.ShortName + '-USDT' == data.tags.InstId
				})
				let valObj = data.fields
				let percent = parseFloat(((valObj.Close - valObj.Yesterday) / valObj.Yesterday * 100).toFixed(2))
				if (index > -1) {

					let bitListBak = [].concat(this.bitList)
					bitListBak[index] = {
						...bitListBak[index],
						...valObj,
						percent,
						count: valObj.Close,
					}
					this.$store.state.bitList = [].concat(bitListBak)
					localStorage.setItem('bitList', JSON.stringify(bitListBak))
					if (this.bitInfo && this.bitInfo.ShortName && this.bitInfo.ShortName + '-USDT' == data.tags.InstId) {
						// 保存上一次价格，计算价格方向
						this.lastPrice = this.currentPrice || parseFloat(valObj.Close)
						this.currentPrice = parseFloat(valObj.Close)

						// 添加调试信息，特别针对SHIB
						if (this.bitInfo.ShortName === 'SHIB') {
							console.log('SHIB价格更新:', {
								rawClose: valObj.Close,
								lastPrice: this.lastPrice,
								currentPrice: this.currentPrice,
								count: this.bitInfo.count,
								bitInfo: this.bitInfo
							})
						}

						// 计算价格方向
						if (this.currentPrice > this.lastPrice) {
							this.priceDirection = 1  // 上涨
						} else if (this.currentPrice < this.lastPrice) {
							this.priceDirection = -1 // 下跌
						} else {
							this.priceDirection = 0  // 无变化
						}

						// SHIB价格方向调试
						if (this.bitInfo.ShortName === 'SHIB') {
							console.log('SHIB价格方向:', {
								direction: this.priceDirection,
								lastPrice: this.lastPrice,
								currentPrice: this.currentPrice
							})
						}

						this.bitInfo = bitListBak[index]
						if (this.showDefault) {
							if(this.tradeMoney === '' || this.tradeMoney === undefined) {
								this.tradeMoney = this.bitInfo.count
								this.tradeMoney2 = this.bitInfo.count
							}
						}
						//计算深度列表
						if (!this.setDeep ) {
							this.getDeepList(valObj.Close)
							this.setDeep = true
						}
						this.newestMoney = parseFloat(valObj.Close)
					}
					if (this.keyword) {
						this.marketList = bitListBak.filter(v => {
							return v.ShortName.toLowerCase().indexOf(this.keyword) > -1
						}).slice(0, 13)
					} else {
						this.marketList = [].concat(bitListBak).slice(0, 13)
					}
				} else {
					// this.bitInfo.percent = percent
					// this.bitInfo.count = valObj.Close
					// this.newestMoney = parseFloat(valObj.Close)
				}
			} else {//交易量
				this.isInitTrade = true
				if (this.bitInfo && this.bitInfo.ShortName && (this.bitInfo.ShortName + '-USDT') == data.tags.InstId) {

					let type = data.fields.Side
					let param = {
						value: data.fields.Price,
						val: parseFloat(data.fields.Price),
						dealCount: this.resetCount(parseFloat(data.fields.Amount)),
						count: data.fields.Amount,
						time: getServerNow().valueOf(),
						type: type
					}
					this.tradeDataBak.push(param)
					let totalList = this.tradeDataBak.filter(v => {
						return v.value == param.value && v.type == param.type
					})
					let total = 0
					totalList.forEach(v => {
						total += parseFloat(v.count)
					})
					total = parseFloat(total.toFixed(8))
					let newParam = {
						...param,
						dealCount: this.resetCount(total),
						count: total,
						time: getServerNow().valueOf(),
					}
					//价格从高到低排列
					if (type == 'Sell') {
						let index = this.allUpDealList.findIndex(v => {
							return v.value == data.fields.Price
						})
						if (index > -1) {
							this.allUpDealList.splice(index, 1, newParam)
						} else {
							this.allUpDealList.push(newParam)
						}

						this.allUpDealList.sort((a, b) => {
							return b.val - a.val
						})
					} else {
						let index = this.allDownDealList.findIndex(v => {
							return v.value == data.fields.Price
						})
						if (index > -1) {
							this.allDownDealList.splice(index, 1, newParam)
						} else {
							this.allDownDealList.push(newParam)
						}
						this.allDownDealList.sort((a, b) => {
							return b.val - a.val
						})
					}

					this.upDealListBak = this.allUpDealList.filter(v => {
						return v.val >= parseFloat(this.bitInfo.count)
					})
					this.downDealListBak = this.allDownDealList.filter(v => {
						return v.val <= parseFloat(this.bitInfo.count)
					})

					if (this.upDealListBak.length < 16) {
						this.upDealListBak = this.allUpDealList.slice(0, 16)
					}
					if (this.downDealListBak.length < 16) {
						this.downDealListBak = this.allDownDealList.slice(this.allDownDealList.length - 16)
					}


					if (this.downDealListBak.length < 16) {
						let size = 16 - this.downDealListBak.length
						let emptyArr = []
						for(let i = 0; i < size; i++) {
							emptyArr.push({
								value: '--',
								val: 0,
								dealCount: '--',
								count: 0
							})
						}
						this.downDealListBak = this.downDealListBak.concat(emptyArr)
					}
					this.initDealList()
				}
			}
		},
		getDeepList(price) {
			let str = price + ''
			let afterSize = str.length - str.indexOf('.') - 1
			if (afterSize < 2) {
				afterSize = 2
			}
			let list = []
			for(let i = 0; i < 4; i++) {
				let val = 10 / Math.pow(10, afterSize - 2 + i)
				if (val < 1) {
					val = val.toFixed(afterSize - 3 + i)
				}
				list.push(val)
			}
			this.deepList = list
			this.deepName = this.deepList[3] + ''
			this.afterSize = this.deepName.length - this.deepName.indexOf('.') - 1
		},
		toPath(path, query) {
			this.$router.push({
				name: path,
				query: query ? query : {}
			})
		},
    changeTab(i) {
			this.tabIndex = i
			this.orderTabIndex = 1
			this.initDealList()
			this.initOrder()
		},
    changeType(type) {
			this.tradeType = type
			this.tradeMoneyPercent = 0
			this.form.number = ''
			this.form.totalMoney = ''
			//刷新钱包数据
			this.initWallet()
		},
		dragStart() {
			this.showPercent = true
		},
		dragEnd() {
			this.showPercent = false
		},
		dragStart2() {
			this.showPercent2 = true
		},
		dragEnd2() {
			this.showPercent2 = false
		},
		dragMultipleStart() {
			this.showMultiplePercent = true
		},
		dragMultipleEnd() {
			this.showMultiplePercent = false
		},
		dragWinStart() {
			this.showWinPercent = true
		},
		dragWinEnd() {
			this.showWinPercent = false
		},
		dragLoseStart() {
			this.showLosePercent = true
		},
		dragLoseEnd() {
			this.showLosePercent = false
		},
		showPicker2() {
			let scrollTop = document.querySelector('.trade-page').scrollTop
			let dom = document.querySelector('.trigger-dom')
			let top = dom.offsetTop
			this.pickerTop2 = top - scrollTop
			this.showPickerModal2 = true
		},
		showPicker3() {
			let scrollTop = document.querySelector('.trade-page').scrollTop
			let dom = document.querySelector('.limit-dom')
			let top = dom.offsetTop
			this.pickerTop3 = top - scrollTop
			this.showPickerModal3 = true
		},
		showMore() {
			let scrollTop = document.querySelector('.trade-page').scrollTop
			let dom = document.querySelector('.trade-info')
			let top = dom.offsetTop
			this.moreTop = top - scrollTop
			if (this.moreTop < -10) {
					this.moreTop = -10
			}
			this.showMoreModal = true
		},
		changeActionType(data) {
			this.actionType = data.value
			this.actionTypeName = data.text
			this.showPickerModal = false
			this.initDealList()
			if (data.value == 1 || data.value == 3) {
				this.showDefault = true
				this.tradeMoney = this.bitInfo.count
				this.tradeMoney2 = this.bitInfo.count
			}
		},
		cancel() {
			this.showPickerModal = false
			this.showPickerModal2 = false
			this.showPickerModal3 = false
			this.showMoreModal = false
			this.showSetting = false
			this.showRate = false
			this.showBit = false
			this.showWinInfo = false
			this.showWinSetting = false
			this.showPopup = false
			this.showAllOrder = false
			this.showUpDownPopup = false
			this.showMultModal = false
			this.showEnsureModal = false
			this.showClearPage = false
			this.showConfirmModal = false
			this.$store.state.showModalBg = false
		},
		showDeepPicker() {
			this.showPopup = true
			this.pickerType = 'deep'
		},
		showTypePicker() {
			this.showPopup = true
			this.pickerType = 'type'
		},
		onConfirm() {
			this.showPopup = false
		},
		initDealList() {
			this.upDealList = this.upDealListBak.slice(0, 16);
			this.downDealList = this.downDealListBak.slice(0,  16);
			if (this.upDealList.length < 16) {
				let defaultList = []
				for (let i = 0; i < 16 - this.upDealList.length; i++) {
					defaultList.push({
						dealCount: '',
						value: ''
					})
				}
				this.upDealList = defaultList.concat(this.upDealList)
			}
			if (this.downDealList.length < 16) {
				let defaultList = []
				for (let i = 0; i < 16 - this.downDealList.length; i++) {
					defaultList.push({
						dealCount: '',
						value: ''
					})
				}
				this.downDealList = this.downDealList.concat(defaultList)
			}
    },
		checkPrice(data) {
			this.tradeMoney = this.resetValue(data.value)
			this.tradeMoney2 = this.resetValue(data.value)
			this.showDefault = false
			if (this.form.number) {
				this.changeCount()
			}
			if (this.form.number2) {
				this.changeCount2()
			}
    },
		initDealListBak(data) {
			let buyList = data.buy
			let sellList = data.sell
			buyList.forEach(v => {
				// 恢复价格去重逻辑，Order Form区域按价格聚合显示
				let index = this.allUpDealList.findIndex(val => {
					return v.Price == val.value  // 查找是否已存在相同价格
				})
				if (index === -1) {  // 只有价格不存在时才添加
					this.allUpDealList.push({
						value: v.Price,
						val: parseFloat(v.Price),
						dealCount: this.resetCount(parseFloat(v.Amount)),
						count: parseFloat(v.Amount)
					})
				} else {
					// 如果价格已存在，累加数量
					this.allUpDealList[index].count += parseFloat(v.Amount)
					this.allUpDealList[index].dealCount = this.resetCount(this.allUpDealList[index].count)
				}
			})
			sellList.forEach(v => {
				// 恢复价格去重逻辑，Order Form区域按价格聚合显示
				let index = this.allDownDealList.findIndex(val => {
					return v.Price == val.value  // 查找是否已存在相同价格
				})
				if (index === -1) {  // 只有价格不存在时才添加
					this.allDownDealList.push({
						value: v.Price,
						val: parseFloat(v.Price),
						dealCount: this.resetCount(parseFloat(v.Amount)),
						count: parseFloat(v.Amount)
					})
				} else {
					// 如果价格已存在，累加数量
					this.allDownDealList[index].count += parseFloat(v.Amount)
					this.allDownDealList[index].dealCount = this.resetCount(this.allDownDealList[index].count)
				}
			})

			this.allUpDealList.sort((a, b) => {
				return b.val - a.val
			})
			this.allDownDealList.sort((a, b) => {
				return b.val - a.val
			})

			this.upDealListBak = this.allUpDealList.filter(v => {
				return v.val >= parseFloat(this.bitInfo.count)
			})
			this.downDealListBak = this.allDownDealList.filter(v => {
				return v.val <= parseFloat(this.bitInfo.count)
			})

			if (this.upDealListBak.length < 16) {
				this.upDealListBak = this.allUpDealList.slice(0, 16)
			}
			if (this.downDealListBak.length < 16) {
				this.downDealListBak = this.allDownDealList.slice(this.allDownDealList.length - 16)
			}
			this.initDealList()
    },
		getSpace() {
			let space = this.deepName
			return space
		},
		resetValue(val) {
			if (isNaN(val)) {
				return val
			} else {
				if (this.afterSize > 0) {
					return parseFloat(val).toFixed(this.afterSize)
				} else if (this.afterSize == 0) {
					return parseInt(val)
				} else {
					return parseInt(val / Math.pow(10, -this.afterSize)) * Math.pow(10, - this.afterSize)
				}
			}
		},
		resetCount(value) {
			let size = 5
			if (value > 10000000) {
				let newNum = value / 1000 / 1000
				return newNum.toFixed(2) + 'M'
			} else if (value > 10000) {
				let newNum = value / 1000
				return newNum.toFixed(2) + 'K'
			} else if (value > 1) {
				let numStr = value + ''
				let beforeSize = numStr.substring(0, numStr.indexOf('.')).length
				let afterSize = size - beforeSize
				return value.toFixed(afterSize)
			} else {
				return parseFloat(value)
			}
		},
		getBgWidth(val, index, type) {
			let data = type == 1 ? this.upPercentList : this.downPercentList
			let dataBak = data[index]
			let max = 100
			if (type == 1) {
				max = 100 - index * 10
			} else {
				max = 50 + index * 10
			}
			if (max > 100) {
				max = 100
			}

			if (!dataBak) {
				let percent = Math.random() * max
				data[index] = {
					val: val,
					width: percent
				}
				return `width: ${val ? percent : 0}%;`
			} else {
				if (val != dataBak.val) {
					let percent = Math.random() * max
					data[index] = {
						val: val,
						width: percent
					}
					return `width: ${val ? percent : 0}%;`
				} else {
					return `width: ${dataBak.width}%;`
				}
			}
		},
		changeDeep() {
			let val = this.deepName
			let str = val + ''
			if (str.indexOf('.') > -1) {
				this.afterSize = str.length - str.indexOf('.') - 1
			} else {
				this.afterSize = 1 - str.length
			}
			this.showPopup = false
		},
		changeDeepType(data) {
			this.deepType = data.type
			this.showPopup = false
			this.initDealList()
		},
		changeOrderTab(i) {
			this.orderTabIndex = i
			clearTimeout(this.orderTimer)
			
			// 如果切换到历史订单标签，清理当前保留的订单列表
			if (i == 3 && this.tabIndex == 2) {
				this.retainedOrderIds = []
				this.retainedOrderTimestamps = {}
				console.log('切换到历史订单，清理保留列表')
			}
			
			if (i == 2) {
				// tab 2 是现货的钱包余额
				this.initBitMoney()
			} else if (i == 3) {
				// tab 3 是期权的历史订单
				this.initHistoryOrder()
			} else {
				// tab 1 是当前订单
				this.initOrder()
			}
		},
		initHistoryOrder() {
			if (!getToken()) {
				return
			}
			clearTimeout(this.orderTimer)

			let form = new FormData()
			form.append('current', 1)
			form.append('pageSize', 50)
			// 获取历史订单（状态为已完成或已取消的订单）
			form.append('Start', moment().subtract(30, 'days').format('YYYY-MM-DD') + ' 00:00:00')
			form.append('End', moment().format('YYYY-MM-DD') + ' 23:59:59')
			
			if (this.isModal) {
				imitateOptionOrderList(form).then(res => {
					// 过滤出已完成的历史订单（状态不为0的订单）
					this.historyOptionOrderArr = res.data.Items.filter(item => item.Status !== 0)
					this.orderTimer = setTimeout(() => {
						this.initHistoryOrder()
					}, 10000) // 历史订单更新频率较低
				})
			} else {
				optionOrderList(form).then(res => {
					// 过滤出已完成的历史订单（状态不为0的订单）
					this.historyOptionOrderArr = res.data.Items.filter(item => item.Status !== 0)
					this.orderTimer = setTimeout(() => {
						this.initHistoryOrder()
					}, 10000) // 历史订单更新频率较低
				})
			}
		},
		toInfo(type) {
			if (type == 'trade') {
				this.showSetting = true
			} else {
				this.showRate = true
			}
			this.showMoreModal = false
		},
		changeBit(data) {
			//取消之前订阅交易量数据
			this.client.unsubscribe(this.tradeWs.id)

			//清空交易数据
			this.upDealListBak = []
			this.downDealListBak = []
			this.allDownDealList = []
			this.allUpDealList = []
			// 清空最新交易数据
			this.tradeDataBak = []

			this.bitInfo = data
			this.tradeMoney = this.bitInfo.count
			this.tradeMoney2 = this.bitInfo.count
			// 重置价格追踪变量
			this.currentPrice = parseFloat(this.bitInfo.count) || 0
			this.lastPrice = this.currentPrice
			this.priceDirection = 0
			this.showDefault = true
			this.showBit = false
			this.isInitTrade = false

			// 延迟触发价格更新，确保chart组件能够接收到新数据
			this.$nextTick(() => {
				// 对于极小数值，添加特殊处理
				const currentPrice = this.currentPrice
				console.log('changeBit 延迟更新价格:', {
					bitName: this.bitInfo.ShortName,
					currentPrice,
					type: typeof currentPrice,
					isValid: !isNaN(currentPrice) && currentPrice > 0
				})

				// 强制触发价格变化，让chart组件重新绘制价格标记线
				this.currentPrice = 0
				this.$nextTick(() => {
					this.currentPrice = currentPrice
					console.log('changeBit 最终价格设置:', {
						bitName: this.bitInfo.ShortName,
						finalPrice: this.currentPrice
					})
				})
			})

			this.initTrade()
			this.init()
			this.initTradeStatistics()

			// 订阅新的交易量数据
			this.tradeWs = this.client.subscribe('/queue/' + this.bitInfo.ShortName.toUpperCase() + '-USDT-trades', message => {
				this.websocketonmessage({
					data: message.body
				});
			})
			this.setDeep = false
		},
		saveWinSetting() {
			this.showBit = false
		},
		changeWinType(type) {
			this.winForm.tradeType = type
		},
		changeFullType(type) {
			this.multForm.fullType = type
		},
		changeMultiple(mult) {
			this.multForm.multiple = mult
		},
		showDetail() {
			this.showWinDesc = !this.showWinDesc
		},
		showOrder() {
			if (!getToken()) {
				this.toPath('login')
				return
			}
			sessionStorage.setItem('bitInfo', JSON.stringify(this.bitInfo))
			this.$router.push({
				name: 'orderList',
				query: {
					type: this.isModal ? (parseInt(this.modalType) + 3) : this.pageType
				}
			})
		},
		changeUpDownPercent(data, isSale) {
			if (isSale) {
				this.futuresObj2 = data
				this.upDownForm.time2 = data.Time
				this.upDownForm.percent2 = data.ProfitRatio
				} else {
				this.futuresObj = data
				this.upDownForm.time = data.Time
				this.upDownForm.percent = data.ProfitRatio
			}
		},
		ensureSubmit() {

			// this.showConfirmModal = false
			// if (this.cancelEnsure) {//不再提示
			// 	if (this.pageType == 1) { // 现货
			// 		this.isSpotEnsure = false
			// 		this.tradeSettingData.SpotOrderConfirm = 2
			// 	} else if (this.pageType == 2) { // 期权
			// 		this.isOptionEnsure = false
			// 		this.tradeSettingData.OptionOrderConfirm = 2
			// 	} else if (this.pageType == 3) { // 合约
			// 		this.isContractEnsure = false
			// 		this.tradeSettingData.FutureOrderConfirm = 2
			// 	} else if (this.isModal) { // 模拟
			// 		this.isImitateEnsure = false
			// 		this.tradeSettingData.SimulationOrderConfirm = 2
			// 	}
			// 	this.updateSetting()
			// }
			this.orderLoading = true
			if (this.ensureType == 'spot') {
				this.doSubmit(this.ensureForm)
			} else if (this.ensureType == 'contract') {
				this.doSubmitContract(this.ensureForm)
			} else if (this.ensureType == 'option') {
				this.doSubmitOption()
			}
		},
		updateSetting() {
			let form = new FormData()
			form.append('OptionOrderConfirm', this.tradeSettingData.OptionOrderConfirm)
			form.append('FutureOrderConfirm', this.tradeSettingData.FutureOrderConfirm)
			form.append('FollowOrderConfirm', this.tradeSettingData.FollowOrderConfirm)
			form.append('SpotOrderConfirm', this.tradeSettingData.SpotOrderConfirm)
			form.append('FinanceOrderConfirm', this.tradeSettingData.FinanceOrderConfirm)
			form.append('SimulationOrderConfirm', this.tradeSettingData.SimulationOrderConfirm)
			updateTradeSetting(form).then(res => {})
		},
		submit(isBuy) {
			if (isBuy) {
				if (!this.form.number) {
					this.$toast.fail( this.i18n.t('trade.error3'))
					return
				}
				if ((this.actionType == 1 || this.actionType == 3 ) && !this.tradeMoney) {
					this.$toast.fail(this.i18n.t('trade.error4'))
					return
				}
				if (this.actionType == 3 && !this.form.stopPrice) {
					this.$toast.fail(this.i18n.t('trade.error7'))
					return
				}
			} else {
				if (!this.form.number2) {
					this.$toast.fail( this.i18n.t('trade.error3'))
					return
				}
				if ((this.actionType == 1 || this.actionType == 3 ) && !this.tradeMoney2) {
					this.$toast.fail(this.i18n.t('trade.error4'))
					return
				}
				if (this.actionType == 3 && !this.form.stopPrice2) {
					this.$toast.fail(this.i18n.t('trade.error7'))
					return
				}
			}
			let Trust = ''
			let number = 0
			let close = 0
			let total = 0
			let stop = ''
			let stopPrice = 0
			if (this.actionType == 1) { // 市交易
				Trust = 'market'
				number = isBuy ? this.form.number : this.form.number2
				total = isBuy ? this.form.totalMoney : this.form.totalMoney2
				close = isBuy ? this.tradeMoney : this.tradeMoney2
			}
			if (this.actionType == 2) { // 限价交易
				Trust = 'limit'
				total = isBuy ? (this.form.number * this.tradeMoney) : (this.form.number2 * this.tradeMoney2)
				number = isBuy ? this.form.number : this.form.number2
				close = isBuy ? this.tradeMoney : this.tradeMoney2
			}
			if (this.actionType == 3) { // 止盈止损
				Trust = 'limit'
				stop = this.form.stop || '1'
				stopPrice = isBuy ? this.form.stopPrice : this.form.stopPrice2
				number = isBuy ? this.form.number : this.form.number2
				total = isBuy ? this.form.totalMoney : this.form.totalMoney2
				close = isBuy ? this.tradeMoney : this.tradeMoney2
			}
			let form = new FormData()
			form.append('Trust', Trust)
			form.append('CurrencyId', this.bitInfo.ID)
			form.append('Trade', isBuy ? 'buy' : 'sell')
			form.append('Number', number)
			form.append('Stop', stop)
			form.append('StopPrice', stopPrice)
			form.append('TrustNum', number)
			form.append('TrustClose', total)
			form.append('Close', close)

			if (this.isSpotEnsure || (this.isModal && this.isImitateEnsure)) {
				this.ensureType = 'spot'
				this.showConfirmModal = true
				// this.$store.state.showModalBg = true
				this.ensureForm = form
				this.ensureData = {
					total: total,
					number: number,
					close: close,
					type: isBuy ? 'buy' : 'sale'
				}
			} else {
				this.doSubmit(form)
			}
		},

		doSubmit(form) {
			spotBuy(form).then(res => {
				this.orderLoading = false
				if (res.code == 0) {
					this.showConfirmModal = false
					this.$toast.success(this.i18n.t(`trade.success4_${this.pageType}`))
					// 记录新创建的订单ID，用于重试机制
					const newOrderId = res.data?.orderId
					if (newOrderId) {
						this.lastCreatedOrderId = newOrderId
						this.orderRetryCount = 0
					}
					this.initOrderWithRetry()
					setTimeout(() => {
						this.initWallet()
					}, 500)
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		submitContract(type) {
			if (type == 'long') { // 做多
				if (this.actionType != 2 && !this.form.number) {
					this.$toast.fail(this.i18n.t('trade.error3'))
					return
				}
				if ((this.actionType == 1 || this.actionType == 3 && this.form.limitType == 1) && !this.tradeMoney) {
					this.$toast.fail(this.i18n.t('trade.error4'))
					return
				}
				// 做多情况下，止盈 > 订单价格 > 止损
				if (this.actionType == 3) {
					if (this.tradeMoney > this.winForm.winMoney) {
						this.$toast.fail(this.$t('trade.label68'))
						return
					}
					if (this.tradeMoney < this.winForm.loseMoney) {
						this.$toast.fail(this.$t('trade.label69'))
						return
					}
				}

			} else { // 做空
				if (this.actionType != 2 && !this.form.number2) {
					this.$toast.fail(this.i18n.t('trade.error3'))
					return
				}
				if ((this.actionType == 1 || this.actionType == 3 && this.form.limitType == 1) && !this.tradeMoney2) {
					this.$toast.fail(this.i18n.t('trade.error4'))
					return
				}
				// 做空情况下，止盈 < 订单价格 < 止损
				if (this.actionType == 3) {
					if (this.tradeMoney < this.winForm.winMoney2) {
						this.$toast.fail(this.$t('trade.label70'))
						return
					}
					if (this.tradeMoney > this.winForm.loseMoney2) {
						this.$toast.fail(this.$t('trade.label71'))
						return
					}
				}
			}

			let Trust = ''
			let number = 0
			let close = 0
			let total = 0
			let takeProfit = ''
			let stopLoss = ''
			if (this.actionType == 1) { // 限价交易
				Trust = 'market'
				number = type == 'long' ? this.form.number : this.form.number2
				total = type == 'long' ? this.form.totalMoney : this.form.totalMoney2
				close = type == 'long' ? this.tradeMoney : this.tradeMoney2
			}
			if (this.actionType == 2) { // 市价交易
				Trust = 'limit'
				total = type == 'long' ? (this.form.number * this.tradeMoney) : (this.form.number2 * this.tradeMoney2)
				number = type == 'long' ? this.form.number : this.form.number2
				close = type == 'long' ? this.tradeMoney : this.tradeMoney2
			}
			if (this.actionType == 3) { // 止盈止损
				Trust = this.form.limitType == 1 ? 'limit' : 'market'
				number = type == 'long' ? this.form.number : this.form.number2
				total = type == 'long' ? this.form.totalMoney : this.form.totalMoney2
				takeProfit = type == 'long' ? this.winForm.winMoney : this.winForm.winMoney2
				stopLoss = type == 'long' ? this.winForm.loseMoney : this.winForm.loseMoney2
				close = type == 'long' ? this.tradeMoney : this.tradeMoney2
			}
			let form = new FormData()
			form.append('CurrencyID', this.bitInfo.ID)
			form.append('Trust', Trust)
			form.append('Direction', type)
			form.append('Multiple', this.multForm.multiple)
			form.append('Full', this.multForm.fullType)
			form.append('TakeProfit', takeProfit)
			form.append('StopLoss', stopLoss)
			form.append('Close', close)

			// form.append('TrustNum', number)
			// form.append('TrustClose', total)

			form.append('MarketPrice', total)
			form.append('Num', number)

			if (this.isContractEnsure || (this.isModal && this.isImitateEnsure)) {
				this.ensureType = 'contract'
				this.showConfirmModal = true
				// this.$store.state.showModalBg = true
				this.ensureForm = form
				this.ensureData = {
					type: type,
					total: total,
					number: number,
					close: close,
					takeProfit: takeProfit,
					stopLoss: stopLoss,
				}
			} else {
				this.doSubmitContract(form)
			}
		},
		doSubmitContract(form) {
			if (this.isModal) {
				imitateContractOrder(form).then(res => {
					this.orderLoading = false
					if (res.code == 0) {
						this.showConfirmModal = false
						this.$toast.success(this.i18n.t(`trade.success4_${this.pageType}`))
						// 记录新创建的订单ID，用于重试机制
						const newOrderId = res.data?.orderId
						if (newOrderId) {
							this.lastCreatedOrderId = newOrderId
							this.orderRetryCount = 0
						}
						this.initOrderWithRetry()
						this.initWallet()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			} else {
				contractOrder(form).then(res => {
					this.orderLoading = false
					if (res.code == 0) {
						this.showConfirmModal = false
						this.$toast.success(this.i18n.t(`trade.success4_${this.pageType}`))
						// 记录新创建的订单ID，用于重试机制
						const newOrderId = res.data?.orderId
						if (newOrderId) {
							this.lastCreatedOrderId = newOrderId
							this.orderRetryCount = 0
						}
						this.initOrderWithRetry()
						this.initWallet()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			}
		},
		submitOption(isSale) {
			this.tradeType = isSale ? 'sell' : 'buy'
			if (isSale) {
				if (!this.futuresObj2) {
					this.$toast.fail(this.i18n.t('trade.error1'))
					return
				}
				if (!this.upDownForm.money2) {
					this.$toast.fail(this.i18n.t('trade.error2'))
					return
				}
			} else {
				if (!this.futuresObj) {
					this.$toast.fail(this.i18n.t('trade.error1'))
					return
				}
				if (!this.upDownForm.money) {
					this.$toast.fail(this.i18n.t('trade.error2'))
					return
				}
			}
			if (this.isOrderEnsure || (this.isModal && this.isImitateEnsure)) {
				this.showConfirmModal = true
				this.ensureType = 'option'
				this.actionDirection = isSale
				this.ensureData = {
					money: isSale ? this.upDownForm.money2 : this.upDownForm.money,
					close: this.bitInfo.count,
					typeName: isSale ? (this.upDownForm.time2 + 'S ' + this.upDownForm.percent2 + '%') : (this.upDownForm.time + 'S ' + this.upDownForm.percent + '%'),
					profit: isSale ? this.profitMoney2 : this.profitMoney
				}
			} else {
				this.doSubmitOption(isSale)
			}
		},
		doSubmitOption(isSale) {
			if (!isSale) {
				isSale = this.actionDirection
			}
			let form = new FormData()
			form.append('CurrencyId', this.bitInfo.ID)
			form.append('Amount', isSale ? this.upDownForm.money2 : this.upDownForm.money)
			form.append('Direction', isSale ? 'fall' : 'rose')
			form.append('SettingId', isSale ? this.futuresObj2.ID : this.futuresObj.ID)
			if (this.isModal) {
				imitateOptionOrder(form).then(res => {
					this.orderLoading = false
					if (res.code == 0) {
						this.showConfirmModal = false
						this.$toast.success(this.i18n.t(`trade.success4_${this.pageType}`))
						this.cancel()
						// 记录新创建的订单ID，用于重试机制
						const newOrderId = res.data?.orderId
						if (newOrderId) {
							this.lastCreatedOrderId = newOrderId
							this.orderRetryCount = 0
						}
						this.initOrderWithRetry()
						this.initWallet()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			} else {
				optionOrder(form).then(res => {
					this.orderLoading = false
					if (res.code == 0) {
						this.showConfirmModal = false
						this.$toast.success(this.i18n.t(`trade.success4_${this.pageType}`))
						this.cancel()
						// 记录新创建的订单ID，用于重试机制
						const newOrderId = res.data?.orderId
						if (newOrderId) {
							this.lastCreatedOrderId = newOrderId
							this.orderRetryCount = 0
						}
						this.initOrderWithRetry()
						this.initWallet()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			}
		},
		// 带重试机制的订单刷新方法
		initOrderWithRetry() {
			// 如果没有新创建的订单ID，直接调用普通的刷新方法
			if (!this.lastCreatedOrderId) {
				this.initOrder()
				return
			}

			// 检查新订单是否已经出现在列表中
			const checkOrderExists = () => {
				let orderExists = false
				if (this.tabIndex === 2) { // 期权订单
					orderExists = this.optionOrderArr.some(order => order.ID === this.lastCreatedOrderId)
				} else if (this.tabIndex === 1) { // 合约订单
					orderExists = this.contractOrderList.some(order => order.ID === this.lastCreatedOrderId)
				} else if (this.tabIndex === 0) { // 现货订单
					orderExists = this.orderList.some(order => order.ID === this.lastCreatedOrderId)
				}
				return orderExists
			}

			// 刷新订单列表
			this.initOrder()

			// 延迟检查订单是否存在
			setTimeout(() => {
				if (!checkOrderExists() && this.orderRetryCount < this.maxRetryCount) {
					this.orderRetryCount++
					console.log(`订单 ${this.lastCreatedOrderId} 未找到，进行第 ${this.orderRetryCount} 次重试`)
					// 递归重试
					setTimeout(() => {
						this.initOrderWithRetry()
					}, 1000 * this.orderRetryCount) // 递增延迟时间
				} else {
					// 重试成功或达到最大重试次数，重置状态
					if (checkOrderExists()) {
						console.log(`订单 ${this.lastCreatedOrderId} 刷新成功`)
					} else {
						console.warn(`订单 ${this.lastCreatedOrderId} 经过 ${this.maxRetryCount} 次重试仍未找到`)
					}
					this.lastCreatedOrderId = null
					this.orderRetryCount = 0
				}
			}, 500) // 给订单列表刷新一些时间
		},
		cancelContract(data) {
			this.showEnsureModal = true
			this.ensureParam = data
			this.ensureType = 'cancelContract'
		},
		doCancelContract(data) {
			let form = new FormData()
			form.append('ID', data.ID)
			if (this.isModal) {
				cancelImitateContractOrder(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t('trade.success2'))
						this.initOrder()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			} else {
				cancelContractOrder(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t('trade.success2'))
						this.initOrder()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			}
		},
		cancelOrder(data) {
			if (this.isCancelOrderEnsure) {
				this.showEnsureModal = true
				this.ensureParam = data
				this.ensureType = 'cancel'
			} else {
				this.doCancelOrder(data)
			}
		},
		doCancelOrder(data) {
			let form = new FormData()
			form.append('ID', data.ID)
			cancelSpotOrder(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success2'))
					this.initOrder()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		ensureMult() {
			this.showMultModal = false
		},
		changeMultSetting() {
			this.showMultModal = true
		},
		startBalanceTimer() {
			this.balanceTimer = setInterval(() => {
				this.refreshBalance()
			}, 3000)
		},
		refreshBalance() {
			if (!getToken()) return
			this.initWallet()
			if (this.tradeType == 'buy') {
				this.initBitMoney()
			}
		},
		changeTotal() {
			if (this.tradeMoney) {
				this.form.number = parseFloat((this.form.totalMoney / this.tradeMoney).toFixed(6))
			} else {
				if (this.form.number) {
					this.tradeMoney =  parseFloat((this.form.totalMoney / this.form.number).toFixed(6))
				}
			}
		},
		changeCount() {
			if (this.tradeMoney) {
				this.form.totalMoney = parseFloat((this.tradeMoney * this.form.number).toFixed(6))
			}
		},
		changeCount2() {
			if (this.tradeMoney2) {
				this.form.totalMoney2 = parseFloat((this.tradeMoney2 * this.form.number2).toFixed(6))
			}
		},
		changeMoney() {
			if (this.form.number) {
				this.form.totalMoney = parseFloat((this.tradeMoney * this.form.number).toFixed(6))
			}
		},
		changeMoney2() {
			if (this.form.number2) {
				this.form.totalMoney2 = parseFloat((this.tradeMoney2 * this.form.number2).toFixed(6))
			}
		},
		changeSlide(val) {
			let money = this.tabIndex == 0 ? this.userMoney : (this.tabIndex == 1 ? this.userContractMoney : this.userOptionMoney)
			this.form.totalMoney = money * (val / 100)
			if (this.tradeMoney) {
				this.form.number = parseFloat((this.form.totalMoney / this.tradeMoney).toFixed(6))
			}
		},
		changeSlide2(val) {
			let money = this.tabIndex == 0 ? this.userBitMoney : (this.tabIndex == 1 ? this.userBitContractMoney : this.userBitOptionMoney)
			this.form.number2 = money * (val / 100)
			if (this.tradeMoney2) {
				this.form.totalMoney2 = parseFloat((this.tradeMoney2 * this.form.number2).toFixed(6))
			}
		},
		ensureAction() {
			this.showEnsureModal = false
			if (this.ensureType == 'cancel') {
				this.doCancelOrder(this.ensureParam)
			} else if (this.ensureType == 'option') {
				this.doSubmitOption()
			} else if (this.ensureType == 'cancelContract') {
				this.doCancelContract(this.ensureParam)
			}
		},
		changeEnsure() {
			this.cancelEnsure = !this.cancelEnsure
		},
		//设置止盈止损
		// setWinOrLose(data) {
		// 	this.showWinSetting = true
		// 	this.showWinInfo = true
		// 	this.winData = data
		// 	this.winForm.winMoney = data.TakeProfit ? data.TakeProfit.toFixed(this.maxSize) : ''
		// 	this.winForm.loseMoney = data.StopLoss ? data.StopLoss.toFixed(this.maxSize) : ''
		// },
		resetSpotMoney(count, id) {
      let index = this.allTradesData.findIndex(v => {
        return v.CurrencyId == id
      })
      if (index > -1) {
        let price = this.allTradesData[index].Price
        return parseFloat(price * count).toFixed(4)
      } else {
        return parseFloat(count).toFixed(4)
      }
    },
		toClearOrder(data) {
			this.orderdetailData = data
			this.showClearPage = true
		},
		submitClear(data) {
			let form = new FormData()
			form.append('ID', this.orderdetailData.ID)
			form.append('PlanTrust', data.type == 1 ? 'market' : 'limit')
			form.append('PlanTrustNum', data.number)
			form.append('PlanTrustPrice', data.price)
			if (this.isModal) {
				imitateContractLiquidation(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t('trade.success3'))
						this.showClearPage = false
						this.initOrder()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			} else {
				contractLiquidation(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t('trade.success3'))
						this.showClearPage = false
						this.initOrder()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			}
		},
		searchMarket() {
      if (!this.keyword) {
        if (this.isSearch) {
          this.clearSearch()
        }
        return
      }
      this.finished = true
      this.isSearch = true
      this.marketList = this.bitList.filter(v => {
        return v.ShortName.toLowerCase().indexOf(this.keyword) > -1
      }).slice(0, 13)
    },
    clearSearch() {
      this.isSearch = false
      this.finished = false
      this.marketList = [].concat(this.bitList).slice(0, 13)
    },
		resetBitMoney(money) {
			// let rate = 1
			// let index = this.allRateList.findIndex(v => {
			// 	return v.Name == this.bitInfo.ShortName
			// })
			// if (index > -1) {
			// 	rate = this.allRateList[index].Rate
			// }
			// return (money * rate).toFixed(4)
			return (money * this.bitInfo.count).toFixed(4)
		},
		resetBitMoney2(money) {
			let rate = 1
			let index = this.allRateList.findIndex(v => {
				return v.Name == this.currencyVal
			})
			if (index > -1) {
				rate = this.allRateList[index].Rate
			}
			return (money * rate).toFixed(4)
		},
		toTransfer() {
			let type = 1
			if (this.pageType == 2) {//期权
				type = 2
			} else if (this.pageType == 3) {//合约
				type = 3
			} else if (this.pageType == 1) {//现货
				type = 4
			} else if (this.isModal && this.modalType == 1) { // 模拟期权
				type = 2
			} else if (this.isModal && this.modalType == 2) { // 模拟合约
				type = 3
			}
			this.$router.push({
				name: 'transfer',
				query: {
					type: type
				}
			})
		},
		toLogin() {
			this.$router.push({ name: 'login', query: { redirect: this.$route.fullPath } })
		},
		getContractClose(close, multiple, type) {
			if (type == 'long') {
				return parseFloat((close * (1 - 1 / multiple)).toFixed(4))
			} else {
				return parseFloat((close * (1 + 1 / multiple)).toFixed(4))
			}
		},
		getContractProfit(close, multiple, type, number) {
			if (type == 'long') {
				return parseFloat((this.bitInfo.count - close) * multiple * number).toFixed(4)
			} else {
				return parseFloat((close - this.bitInfo.count) * multiple * number).toFixed(4)
			}
		},
		resetTime(time) {
			return formatServerTimeEn(time, 'hh:mm:ss A')
		},
		formatOpenTime(time) {
			return formatServerTimeEn(time, 'YYYY-MM-DD hh:mm:ss A')
		},
		formatSettlementTime(time) {
			return formatServerTimeEn(time, 'YYYY-MM-DD hh:mm:ss A')
		},
		formatOrderDateTime(time) {
			return formatServerTimeEn(time, 'YYYY-MM-DD hh:mm:ss A')
		},
		getCountdownTime(item) {
			// 检查Settlement是否为有效数值
			const settlement = parseInt(item.Settlement, 10);
			if (isNaN(settlement) || settlement <= 0) {
				console.error('Invalid Settlement value:', item.Settlement);
				return '0S';
			}

			try {
				// 获取服务器时区，默认为 Asia/Shanghai
				const serverTimezone = this.$store.state.timeZone || 'Asia/Shanghai';
				
				// 创建服务器时间（服务器返回的时间是服务器时区的时间）
				const createdAt = moment.tz(item.CreatedAt, serverTimezone);
				// 获取当前服务器时区的时间（基于服务器时间偏移）
				const currentTime = getServerNow();

				// 检查创建时间是否有效
				if (!createdAt.isValid()) {
					console.error('Invalid CreatedAt date:', item.CreatedAt);
					return '0S';
				}

				// 计算已经过的秒数（使用服务器时区统一计算）
				const elapsedSeconds = Math.floor(currentTime.diff(createdAt) / 1000);

				// 如果已过时间为负数（可能是服务器时间与本地时间不同步），则返回完整时间
				if (elapsedSeconds < 0) {
					console.warn('Time difference is negative, possible server-client time mismatch', {
						createdAt: item.CreatedAt,
						serverTime: currentTime.format('YYYY-MM-DD HH:mm:ss'),
						localTime: moment().format('YYYY-MM-DD HH:mm:ss'),
						diff: elapsedSeconds,
						timezone: serverTimezone
					});
					return settlement + 'S';
				}

				// 计算剩余秒数 = 总结算秒数 - 已经过秒数
				const remainingSeconds = settlement - elapsedSeconds;

				// 日志记录用于调试
				if (remainingSeconds <= 0) {
					console.log('Countdown completed', {
						id: item.ID,
						createdAt: item.CreatedAt,
						serverTime: currentTime.format('YYYY-MM-DD HH:mm:ss'),
						localTime: moment().format('YYYY-MM-DD HH:mm:ss'),
						elapsed: elapsedSeconds,
						settlement: settlement,
						remaining: remainingSeconds,
						timezone: serverTimezone
					});
				}

				// 确保不小于0
				return Math.max(0, remainingSeconds) + 'S';
			} catch (error) {
				console.error('Error calculating countdown:', error);
				return '0S';
			}
		},
		startCountdownTimer() {
			// 清除已有的定时器
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer);
			}
			
			this.countdownTimer = setInterval(() => {
				// 移除时间处理逻辑，直接使用接口返回的原始SettlementTime数据
				// 只需要触发视图更新，让getCountdownTime重新计算倒计时
				this.$forceUpdate();
			}, 1000);
		},
		handleSpotSubmit(data) {
			// 处理现货交易组件传来的提交事件
			const { isBuy, actionType, tradeMoney, form } = data

			// 验证输入
			if (isBuy) {
				if (!form.number) {
					this.$toast.fail(this.i18n.t('trade.error3'))
					return
				}
				if ((actionType == 1 || actionType == 3) && !tradeMoney) {
					this.$toast.fail(this.i18n.t('trade.error4'))
					return
				}
				if (actionType == 3 && !form.stopPrice) {
					this.$toast.fail(this.i18n.t('trade.error7'))
					return
				}
			} else {
				if (!form.number2) {
					this.$toast.fail(this.i18n.t('trade.error3'))
					return
				}
				if ((actionType == 1 || actionType == 3) && !tradeMoney) {
					this.$toast.fail(this.i18n.t('trade.error4'))
					return
				}
				if (actionType == 3 && !form.stopPrice2) {
					this.$toast.fail(this.i18n.t('trade.error7'))
					return
				}
			}

			// 调用原有的 submit 方法
			this.submit(isBuy)
		},
		handleContractSubmit(data) {
			// 处理合约交易组件传来的提交事件
			const { type, actionType, tradeMoney, form, winForm, multForm } = data

			// 同步组件数据到主组件
			this.multForm = multForm
			this.winForm = winForm

			// 验证输入
			if (type == 'long') { // 做多
				if (actionType != 2 && !form.number) {
					this.$toast.fail(this.i18n.t('trade.error3'))
					return
				}
				if ((actionType == 1 || actionType == 3 && this.form.limitType == 1) && !tradeMoney) {
					this.$toast.fail(this.i18n.t('trade.error4'))
					return
				}
				// 做多情况下，止盈 > 订单价格 > 止损
				if (actionType == 3) {
					if (tradeMoney > winForm.winMoney) {
						this.$toast.fail(this.$t('trade.label68'))
						return
					}
					if (tradeMoney < winForm.loseMoney) {
						this.$toast.fail(this.$t('trade.label69'))
						return
					}
				}
			} else { // 做空
				if (actionType != 2 && !form.number2) {
					this.$toast.fail(this.i18n.t('trade.error3'))
					return
				}
				if ((actionType == 1 || actionType == 3 && this.form.limitType == 1) && !tradeMoney) {
					this.$toast.fail(this.i18n.t('trade.error4'))
					return
				}
				// 做空情况下，止盈 < 订单价格 < 止损
				if (actionType == 3) {
					if (tradeMoney < winForm.winMoney2) {
						this.$toast.fail(this.$t('trade.label70'))
						return
					}
					if (tradeMoney > winForm.loseMoney2) {
						this.$toast.fail(this.$t('trade.label71'))
						return
					}
				}
			}

			// 调用原有的 submitContract 方法
			this.submitContract(type)
		},
		handleOptionSubmit(data) {
			// 处理期权交易组件传来的提交事件
			const { isSale, upDownForm, futuresObj, profitMoney } = data

			// 同步组件数据到主组件
			this.upDownForm = upDownForm
			this.tradeType = isSale ? 'sell' : 'buy'

			// 验证输入
			if (isSale) {
				if (!futuresObj || !futuresObj.ID) {
					this.$toast.fail(this.i18n.t('trade.error1'))
					return
				}
				if (!upDownForm.money2) {
					this.$toast.fail(this.i18n.t('trade.error2'))
					return
				}
			} else {
				if (!futuresObj || !futuresObj.ID) {
					this.$toast.fail(this.i18n.t('trade.error1'))
					return
				}
				if (!upDownForm.money) {
					this.$toast.fail(this.i18n.t('trade.error2'))
					return
				}
			}

			// 同步期权对象到主组件
			if (isSale) {
				this.futuresObj2 = futuresObj
			} else {
				this.futuresObj = futuresObj
			}

			// 调用原有的 submitOption 方法
			this.submitOption(isSale)
		},
		toggleBalance() {
			this.hideBalance = !this.hideBalance
		},
		detectOrderStatusChange(items) {
			// 检测订单状态变化，当订单从Status == 0变成其他状态时，添加到保留列表
			items.forEach(item => {
				// 如果订单已经结算且不在保留列表中，检查是否需要添加到保留列表
				if (item.Status !== 0 && !this.retainedOrderIds.includes(item.ID)) {
					// 检查这个订单之前是否存在于当前订单列表中且状态为0
					const existingOrder = this.optionOrderArr.find(existingItem => existingItem.ID === item.ID)
					if (existingOrder && existingOrder.Status === 0) {
						// 订单状态发生了变化（从进行中变为已结算），添加到保留列表
						this.retainedOrderIds.push(item.ID)
						this.retainedOrderTimestamps[item.ID] = getServerNow().valueOf()
						console.log(`订单 ${item.ID} 从未结算状态变为已结算，保留在当前订单列表中5分钟`)
					}
				}
				
				// 如果订单状态变回0（重新开始），从保留列表中移除
				if (item.Status === 0 && this.retainedOrderIds.includes(item.ID)) {
					const index = this.retainedOrderIds.indexOf(item.ID)
					this.retainedOrderIds.splice(index, 1)
					delete this.retainedOrderTimestamps[item.ID]
					console.log(`订单 ${item.ID} 状态变回未结算，从保留列表中移除`)
				}
			})
		},
		cleanExpiredRetainedOrders() {
			// 清理超过5分钟的保留订单
			const currentTime = getServerNow().valueOf()
			const initialLength = this.retainedOrderIds.length
			
			this.retainedOrderIds = this.retainedOrderIds.filter(id => {
				const timestamp = this.retainedOrderTimestamps[id]
				if (timestamp && currentTime - timestamp > 5 * 60 * 1000) { // 5分钟过期
					delete this.retainedOrderTimestamps[id]
					console.log(`订单 ${id} 保留时间已过期，从当前订单列表中移除`)
					return false
				}
				return true
			})
			
			if (this.retainedOrderIds.length !== initialLength) {
				console.log(`清理了 ${initialLength - this.retainedOrderIds.length} 个过期的保留订单`)
			}
		},
		isRetainedOrder(orderId) {
			// 检查订单是否在保留列表中
			return this.retainedOrderIds.includes(orderId)
		},
		getRetainedOrderRemainingTime(orderId) {
			// 获取保留订单的剩余时间（秒）
			const timestamp = this.retainedOrderTimestamps[orderId]
			if (!timestamp) return 0
			
			const currentTime = getServerNow().valueOf()
			const elapsed = currentTime - timestamp
			const remaining = (5 * 60 * 1000) - elapsed // 5分钟总时长
			
			return Math.max(0, Math.floor(remaining / 1000))
		}
  },
}
</script>
<style lang="less">
/* 保留订单样式 */
.retained-order {
  background-color: rgba(255, 193, 7, 0.1) !important;
  border-left: 3px solid #ffc107;
  animation: fadeIn 0.5s ease-in-out;
}

.retained-label {
  background-color: #ffc107;
  color: #212529;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 8px;
  font-weight: bold;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
